import { formatCurrency } from 'common/constants/currency';
import { dateTimeAMPMFormat, formatDateSimple, formatShortMonthDate } from 'utils/formatDate';
import { currencyFormatter, getFirstAndLastName } from 'utils/formatters';
import { ContractingType } from 'v3/data/store/contracting/types';
import { IDevice } from 'v3/data/store/device/types';
import { IPerson } from 'v3/data/store/person/types';
import { IProduct, IProposal } from 'v3/data/store/proposal/types';
import { ISellerState } from 'v3/data/store/seller/types';
import { IReceipt } from 'v3/pages/Receipt/types';

export const receiptFactory = (
  proposal: IProposal,
  person: IPerson,
  contracting: ContractingType,
  product: IProduct,
  device: IDevice,
  seller: ISellerState,
): IReceipt => {
  const currentDate = new Date();

  const total =
    product.price * 100 +
    proposal.financingDetails.accessoriesValue * 100 +
    proposal.financingDetails.insuranceValue * 100 -
    product.discount * 100;

  return {
    person: {
      fullName: person.person.fullName,
      fullAddress: person?.person?.address
        ? `${person.person.address.street}, ${person.person.address.number} - ${person.person.address.neighborhood}`
        : '-',
      cpf: person.person.cpf,
      phoneNumber:
        person?.person?.phoneAreaCode && person?.person?.phoneNumber
          ? `${person.person.phoneAreaCode}${person.person.phoneNumber}`
          : '-',
    },
    product: {
      model: product.name,
      discount: product.discount,
      price: currencyFormatter((product.price - product.discount) * 100),
      totalValue: proposal.financing?.totalFinancingAmount
        ? currencyFormatter(proposal.financing.totalFinancingAmount * 100)
        : '',
      financingValue: proposal.financing?.requestedAmount
        ? currencyFormatter(proposal.financing.requestedAmount * 100)
        : '',
      inputValue: currencyFormatter(proposal.financing.inputValue * 100),
      numberOfInstallments: proposal.financing.numberOfInstallments,
      insurance: proposal.financingDetails.insuranceName,
      insuranceValue: proposal?.financingDetails?.insuranceValue
        ? formatCurrency(proposal.financingDetails.insuranceValue)
        : '-',
      accessoryValue: proposal?.financingDetails?.accessoriesValue
        ? formatCurrency(proposal.financingDetails.accessoriesValue)
        : '-',
      productsSubtotal: currencyFormatter(total),
      releasedAmount: currencyFormatter(proposal.financing.releasedAmount * 100),
      firstInstallmentDate: formatShortMonthDate(proposal.financing.firstInstallmentDate),
      installmentValue: formatCurrency(proposal.financing.installmentValue)
    },
    store: {
      name: contracting.creditSimulation.store.name,
      date: dateTimeAMPMFormat(contracting.contractSignDate),
    },
    device: {
      imei: device.imei,
    },
    seller: {
      name: getFirstAndLastName(seller.seller.name),
    },
    nowDate: formatDateSimple(currentDate.toISOString()),
  };;
};
